import { useSearchParams } from 'react-router-dom';
import { safePathName } from '../../../utils/helpers';

export function SsoLogin() {
  const backendUrl = `${process.env.REACT_APP_API_SERVER_URL}/auth/sso`;
  const [params] = useSearchParams();

  const handleSsoLogin = () => {
    const redirectTo = params.get('redirectTo');
    if (redirectTo) {
      sessionStorage.setItem('postLoginRedirect', safePathName(redirectTo));
    } else {
      // An SSO sign-in abandoned at the provider must not send this one to where it was headed.
      sessionStorage.removeItem('postLoginRedirect');
    }
  };

  const authOriginUrl = window.location.origin;

  return (
    <div className="flex justify-center mt-4 w-full">
      <a
        href={`${backendUrl}?resource_class=PortalUser&auth_origin_url=${encodeURIComponent(authOriginUrl)}`}
        onClick={handleSsoLogin}
        className="text-sm text-blue-500 underline cursor-pointer flex items-center gap-2">
        UPSTACK Employee Login
      </a>
    </div>
  );
}
